import React from "react";
import { InputAdapter, inputProps } from "./InputAdapter";
import { inputType } from "./inputConstants";

export const TextField = (props) => {
    return <InputAdapter {...props} inputType={inputType.TEXT}/>;
};

TextField.propTypes = {...inputProps};